const $ = require('jquery');

const textareaInit = function () {
  $('.mtui-textarea__input').on('input', function () {
    const $wrapper = $(this).closest('.mtui-textarea__wrapper');
    this.style.height = 'auto';
    this.style.height = this.scrollHeight + 2 + 'px';
    if ($(this).val().length > 0) {
      $wrapper.addClass('mtui-textarea__filled');
    } else {
      $wrapper.removeClass('mtui-textarea__filled');
    }
    if ($wrapper.data('max') > 0 && $(this).val().length > $wrapper.data('max')) {
      $(this).val($(this).val().slice(0, $wrapper.data('max')));
    }
    if ($wrapper.find('.mtui-textarea__counter').length > 0) {
      $wrapper.find('.mtui-textarea__counter_value').text($(this).val().length);
    }
  });
};

export { textareaInit };
